/* eslint-disable camelcase */
import SellItPerformance from './sell-it-performance';
import { destandard } from '../../../utils/commonFunctions';

const SellItPerformances = (props) => {
  const { performances } = props;

  return (
    <div>
      {
        performances.map((value, key) => {
          const performance = destandard({...value});
          return (
            performance.incentives && performance.incentives.length && (
            <SellItPerformance
              {...performance}
              key={key}
              index={key}
              outlet={value.id}
            />
          )
        ) || false;
        })
      }
    </div>
  );
};

export default SellItPerformances;

